/* ============================================
   DAINO THEME - SCROLL ANIMATIONS & GIANT VISUAL
   Converted from exo_sk.html
   ============================================ */
(function () {
    'use strict';

    function initAnimations() {
        if (typeof gsap === 'undefined') {
            return;
        }

        const isMobile = window.matchMedia('(max-width: 767px)').matches || window.matchMedia('(pointer: coarse)').matches;

        // ========================================
        // PATH A: ScrollTrigger disponibile (homepage)
        // ========================================
        if (typeof ScrollTrigger !== 'undefined') {
            gsap.registerPlugin(ScrollTrigger);

            const toggleActions = isMobile ? "play none none none" : "play none none reverse";

            // 1. GLOBAL SCROLL REVEAL (Batch)
            const revealSections = document.querySelectorAll('.scroll-reveal');
            if (revealSections.length > 0) {
                ScrollTrigger.batch('.scroll-reveal', {
                    onEnter: (elements) => {
                        gsap.to(elements, {
                            opacity: 1,
                            y: 0,
                            duration: 0.8,
                            stagger: 0.1,
                            overwrite: true
                        });
                        elements.forEach(el => {
                            setTimeout(() => {
                                el.style.willChange = 'auto';
                            }, 1500);
                        });
                    },
                    start: "top 85%",
                    once: true
                });
            }

            // 1B. SCROLL REVEAL CARDS (Staggered)
            const revealCards = document.querySelectorAll('.scroll-reveal-card');
            if (revealCards.length > 0) {
                gsap.utils.toArray(revealCards).forEach((card) => {
                    const delay = parseFloat(card.dataset.delay) || 0;
                    gsap.fromTo(card,
                        { opacity: 0, y: 40 },
                        {
                            opacity: 1,
                            y: 0,
                            duration: 0.8,
                            delay: delay,
                            scrollTrigger: {
                                trigger: card,
                                start: "top 90%",
                                toggleActions: toggleActions
                            }
                        }
                    );
                });
            }

            // Narrative text lines
            gsap.utils.toArray('.reveal-text').forEach((line) => {
                gsap.fromTo(line,
                    { opacity: 0, y: 30 },
                    {
                        opacity: 1,
                        y: 0,
                        duration: 1,
                        scrollTrigger: {
                            trigger: line,
                            start: "top 90%",
                            toggleActions: toggleActions
                        }
                    }
                );
            });

            // 2. GIANT VISUAL SECTION (STICKY PINNING)
            const giantSection = document.querySelector('.giant-visual-section');
            if (giantSection) {
                const scrubValue = isMobile ? 0.5 : true;

                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".giant-visual-section",
                        start: "top top",
                        end: "bottom bottom",
                        scrub: scrubValue,
                    }
                });

                tl.to('.giant-visual-wrapper', { scale: 1.25, duration: 1 }, 0);
                tl.to('.giant-copy-block:nth-child(1)', { opacity: 1, duration: 0.15 }, 0.05);
                tl.to('.giant-copy-block:nth-child(1)', { opacity: 0, duration: 0.15 }, 0.30);
                tl.to('.giant-copy-block:nth-child(2)', { opacity: 1, duration: 0.15 }, 0.35);
                tl.to('.giant-copy-block:nth-child(2)', { opacity: 0, duration: 0.15 }, 0.65);
                tl.to('.giant-copy-block:nth-child(3)', { opacity: 1, duration: 0.15 }, 0.70);
            }

            // ========================================
            // PATH B: Senza ScrollTrigger (prodotto/catalogo)
            // IntersectionObserver nativo — zero scroll hijack
            // ========================================
        } else {
            const observerCallback = (entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        gsap.to(entry.target, {
                            opacity: 1,
                            y: 0,
                            duration: 0.8,
                            ease: 'power2.out',
                            onComplete: () => {
                                entry.target.style.willChange = 'auto';
                            }
                        });
                        observer.unobserve(entry.target);
                    }
                });
            };

            const observer = new IntersectionObserver(observerCallback, {
                threshold: 0.15,
                rootMargin: '0px 0px -10% 0px'
            });

            // Observe all reveal elements
            document.querySelectorAll('.scroll-reveal, .scroll-reveal-card, .reveal-text, .fade-in-up').forEach(el => {
                observer.observe(el);
            });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAnimations);
    } else {
        initAnimations();
    }
})();
